// extracted by mini-css-extract-plugin
export var bubble = "_35-0";
export var container = "_35-3";
export var contrastBorder = "_35-4";
export var greyOut = "_35-2";
export var initialsWrapper = "_35-1";
export var large = "_35-9";
export var medium = "_35-8";
export var mediumSmall = "_35-7";
export var mediumSmallMedium = "_35-c";
export var micro = "_35-5";
export var small = "_35-6";
export var tiny = "_35-b";
export var xTiny = "_35-a";